import { useState } from "react";
import { X, Send, CheckCircle2 } from "lucide-react";
import { api } from "../lib/api";

const fld = "w-full bg-[#0A0A0B] border border-[#2A2B31] px-4 py-3 text-sm text-white focus:outline-none focus:border-[#E10600]";
const lbl = "font-mono-tt text-[10px] uppercase tracking-widest text-[#9A9CA3] block mb-1";

const MODES = {
  testrit: { kicker: "Vraag een testrit aan", onderwerp: "Testritaanvraag", ph: "Bericht (optioneel), bv. gewenste dag of rijbewijs", success: "Bedankt voor je testritaanvraag!" },
  info: { kicker: "Informeer naar", onderwerp: "Interesse QJ Motor", ph: "Je vraag (optioneel)", success: "Bedankt voor je aanvraag!" },
};

export default function QJInquiryModal({ model, mode = "testrit", onClose }) {
  const cfg = MODES[mode];
  const [f, setF] = useState({ naam: "", email: "", telefoon: "", bericht: "", honeypot: "" });
  const [state, setState] = useState("idle");
  const set = (k, v) => setF((p) => ({ ...p, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    setState("sending");
    const bericht = `${cfg.onderwerp} voor: ${model.naam}\n\n${f.bericht || "(geen extra bericht)"}`;
    try {
      await api.post("/contact", { ...f, bericht, onderwerp: `${cfg.onderwerp}: ${model.naam}` });
      setState("sent");
    } catch { setState("error"); }
  };

  return (
    <div className="fixed inset-0 z-[80] bg-black/80 backdrop-blur-sm flex items-center justify-center px-4" data-testid="qj-inquiry-modal" onClick={onClose}>
      <div className="bg-[#141518] border border-[#2A2B31] w-full max-w-lg max-h-[90vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between px-6 py-4 border-b border-[#2A2B31]">
          <div>
            <p className="font-mono-tt text-[10px] uppercase tracking-widest text-[#E10600]">{cfg.kicker}</p>
            <h3 className="font-display uppercase font-800 text-xl text-white">{model.naam}</h3>
          </div>
          <button onClick={onClose} data-testid="qj-inquiry-close" className="text-[#9A9CA3] hover:text-white"><X size={22} /></button>
        </div>
        {state === "sent" ? (
          <div className="p-8 text-center" data-testid="qj-inquiry-success">
            <CheckCircle2 size={44} className="text-[#E10600] mx-auto mb-4" />
            <p className="font-display uppercase font-700 text-white text-lg mb-2">{cfg.success}</p>
            <p className="text-[#9A9CA3] text-sm mb-6">Je aanvraag voor de {model.naam} is goed ontvangen. We nemen zo snel mogelijk contact met je op.</p>
            <button onClick={onClose} data-testid="qj-inquiry-done" className="border border-[#2A2B31] hover:border-white text-white px-6 py-3 font-display uppercase font-700 text-sm">Sluiten</button>
          </div>
        ) : (
          <form onSubmit={submit} className="p-6 space-y-3">
            <div><label className={lbl}>Model</label><input data-testid="qj-inq-model" readOnly value={model.naam} className={`${fld} text-[#B8B9BE]`} /></div>
            <input data-testid="qj-inq-naam" required placeholder="Naam *" value={f.naam} onChange={(e) => set("naam", e.target.value)} className={fld} />
            <input data-testid="qj-inq-telefoon" required type="tel" placeholder="Telefoonnummer *" value={f.telefoon} onChange={(e) => set("telefoon", e.target.value)} className={fld} />
            <input data-testid="qj-inq-email" required type="email" placeholder="E-mailadres *" value={f.email} onChange={(e) => set("email", e.target.value)} className={fld} />
            <textarea data-testid="qj-inq-bericht" rows={3} placeholder={cfg.ph} value={f.bericht} onChange={(e) => set("bericht", e.target.value)} className={fld} />
            <input type="text" tabIndex={-1} autoComplete="off" value={f.honeypot} onChange={(e) => set("honeypot", e.target.value)} className="hidden" />
            {state === "error" && <p data-testid="qj-inq-error" className="text-[#E10600] text-sm">Verzenden mislukt. Probeer opnieuw of bel ons.</p>}
            <button data-testid="qj-inq-submit" disabled={state === "sending"}
              className="w-full bg-[#E10600] hover:bg-[#B80500] disabled:opacity-60 text-white font-display uppercase font-700 tracking-wide py-4 flex items-center justify-center gap-2 transition-colors">
              <Send size={16} /> {state === "sending" ? "Versturen..." : "Verstuur aanvraag"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
